import { useCallback, useEffect } from 'react';
import { CallIntelligenceEventType } from '@weave/schema-gen-ts/dist/shared/call-intelligence/notification/enums.pb';
import { TrialBackfillEventPayload } from '@weave/schema-gen-ts/dist/shared/call-intelligence/notification/message.pb';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { CallIntelligenceWetags } from '@wetags/call-intelligence';
import { useQueryClient } from 'react-query';
import { CallIntelligenceV2 } from '@frontend/api-call-intel';
import { useWebsocketEventPublisher } from '@frontend/websocket';

export const useBackfillWebsocketSubscription = () => {
  const queryClient = useQueryClient();
  const publisher = useWebsocketEventPublisher();

  const [isTrialBackfillEnabled] = CallIntelligenceWetags.useWetag('call-intel-trial-backfill');

  const handleBackfillEvent = useCallback(
    (event: { params: TrialBackfillEventPayload }) => {
      const { eventType } = event.params;

      if (
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_BATCH1_READY &&
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_FULLY_COMPLETE &&
        eventType !== CallIntelligenceEventType.CALL_INTELLIGENCE_EVENT_TYPE_TRIAL_BACKFILL_WAITING_FOR_LIVE_CALLS
      ) {
        return;
      }

      // Invalidate all call-intel queries
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return Array.isArray(key) && key[0] === CallIntelligenceV2.serviceName;
        },
      });
    },
    [queryClient]
  );

  useEffect(() => {
    if (!isTrialBackfillEnabled) return;

    publisher.on(NotificationType.CALL_INTELLIGENCE_TRIAL, handleBackfillEvent);
    return () => {
      publisher.off(NotificationType.CALL_INTELLIGENCE_TRIAL, handleBackfillEvent);
    };
  }, [isTrialBackfillEnabled, publisher, handleBackfillEvent]);
};
